import React, { Component, Fragment } from 'react';
import { HashRouter, Redirect, Route } from 'react-router-dom';
import VideoPlayer from './components/VideoPlayer/VideoPlayer';
import Modal from './components/Modal/Modal';
import Contact from './components/Contact/Contact';
import RecentStreams from './components/RecentStreams/RecentStreams';
import Button from './components/Button/Button';
import Header from "./components/Header/Header";

class StreamPage extends Component {

  constructor(props) {
    super();
    
    this.state = {
      page: "live",
    }
  }

  showRecentStreams = () => {
    this.setState({
      page: "recent",
    })
  }

  showLiveStream = () => {
    this.setState({
      page: "live",
    })
  }

  render() {
    const videoJsOptions = {
      autoplay: "autoplay",
      controls: true,
      sources: [{
        src: `https://domestream.xyz/hls/${process.env.REACT_APP_STREAM_KEY}.m3u8`,
        type: 'application/x-mpegURL'
      }]
    };

    if (process.env.REACT_APP_STREAM_KEY === "demo") {
      videoJsOptions.sources[0] = {
        src: `https://domestream.xyz/demo.mp4`,
        type: 'video/mp4'
      };
    }

    let content;

    switch (this.state.page) {
      case "recent":
        content = <RecentStreams onClick={this.showLiveStream}/>;
        break;
      case "live":
        content = (
          <React.Fragment>
            <VideoPlayer { ...videoJsOptions } />
            <Button
              className="archive"
              onClick={this.showRecentStreams}
            >
              View Recent Streams
            </Button>
          </React.Fragment>
        );
    }

    return (
      <Fragment>
        <Header />
        {
          this.state.modalOpen &&
          <Modal title="Contact" onClose={() => this.setState({modalOpen: false})}>
            <Contact />
          </Modal>
        }

        {content}
        <div className="footer">
          <div className="dome-logo">
            <a href="https://domestream.xyz">
              <img src="images/domestream.png" />
            </a>
          </div>
          <div className="copyright">
            Streaming solution &copy; Domestream 2020. For enquiries&nbsp;
            <a onClick={() => this.setState({modalOpen: true})}>contact us</a>.
          </div>
        </div>
      </Fragment>
    );
  }
}

export default StreamPage;
